import { createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/images/cursor_left_bottom.png'


const _hoisted_1 = { class: "pantry-used-up-check-page" }
const _hoisted_2 = { class: "pantry-used-up-check-page-area" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "pantry-used-up-check-page-message-area" }, [
  /*#__PURE__*/_createVNode("div", { class: "pantry-user-up-check-page-message-text" }, " 削除したい食材を選択してください。 ")
], -1)
const _hoisted_4 = { class: "pantry-used-up-check-page-list-area" }
const _hoisted_5 = { class: "pantry-user-up-check-page-contents-area" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "pantry-user-up-check-page-contents-name" }, "品目", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "pantry-user-up-check-page-contents-date" }, "入庫日", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "pantry-user-up-check-page-contents-check" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "pantry-user-up-check-page-contents-area" }, [
  /*#__PURE__*/_createVNode("div", { class: "pantry-user-up-check-page-contents-name" }, "品目"),
  /*#__PURE__*/_createVNode("div", { class: "pantry-user-up-check-page-contents-date" }, "入庫日"),
  /*#__PURE__*/_createVNode("div", { class: "pantry-user-up-check-page-contents-check" })
], -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "pantry-used-up-check-page-empty" }, null, -1)
const _hoisted_11 = { class: "pantry-used-up-check-page-header" }
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  class: "pantry-used-up-check-page-image-icon",
  src: _imports_0
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "pantry-used-up-check-page-title-text" }, "在庫メンテナンス", -1)
const _hoisted_14 = { class: "pantry-used-up-check-page-bottom-bar-area" }
const _hoisted_15 = { class: "pantry-used-up-check-page-button-bottom" }
const _hoisted_16 = { class: "pantry-used-up-check-page-button-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PantryUsedUpTitleView = _resolveComponent("PantryUsedUpTitleView")
  const _component_PantryUsedUpEmptyView = _resolveComponent("PantryUsedUpEmptyView")
  const _component_PantryUsedUpCheckView = _resolveComponent("PantryUsedUpCheckView")
  const _component_CommonDesignDialog = _resolveComponent("CommonDesignDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _withDirectives(_createVNode(_component_PantryUsedUpTitleView, {
          title: 'カメラから見えなくなったもの',
          buttonLabel: '庫内を確認する',
          onClickButton: _ctx.onClickCamera
        }, null, 8, ["onClickButton"]), [
          [_vShow, _ctx.isShowCameraList]
        ]),
        _withDirectives(_createVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _hoisted_8
        ], 512), [
          [_vShow, _ctx.isShowCameraList]
        ]),
        (_ctx.isEmptyPantryDeleteList())
          ? (_openBlock(), _createBlock(_component_PantryUsedUpEmptyView, { key: 0 }))
          : (_openBlock(), _createBlock(_component_PantryUsedUpCheckView, _mergeProps({ key: 1 }, _ctx.usedUpPantryDeleteList, {
              data: _ctx.usedUpPantryDeleteList,
              onSelectTag: _ctx.onSelectDeleteTag
            }), null, 16, ["data", "onSelectTag"])),
        _createVNode(_component_PantryUsedUpTitleView, { title: '食材リスト' }),
        _hoisted_9,
        (_ctx.isEmptyPantryList())
          ? (_openBlock(), _createBlock(_component_PantryUsedUpEmptyView, { key: 2 }))
          : (_openBlock(), _createBlock(_component_PantryUsedUpCheckView, _mergeProps({ key: 3 }, _ctx.usedUpPantryList, {
              data: _ctx.usedUpPantryList,
              onSelectTag: _ctx.onSelectTag
            }), null, 16, ["data", "onSelectTag"]))
      ]),
      _hoisted_10
    ]),
    _withDirectives(_createVNode("div", _hoisted_11, [
      _createVNode("div", {
        class: "pantry-used-up-check-page-image",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickBack(...args)))
      }, [
        _hoisted_12
      ]),
      _hoisted_13
    ], 512), [
      [_vShow, _ctx.isShowBack]
    ]),
    _createVNode("div", _hoisted_14, [
      _createVNode("div", {
        class: "pantry-used-up-check-page-button",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickBottom(...args)))
      }, [
        _createVNode("div", _hoisted_15, [
          _createVNode("div", _hoisted_16, _toDisplayString(_ctx.getBottomMessage()), 1)
        ])
      ])
    ]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: _ctx.isShowComplite,
      dialogType: 20,
      title: 'パントリーが更新されました',
      message: 
        'いつもチェックありがとうございます。この内容をもとに新しいおすすめを提案します。'
      ,
      positiveLabel: '完了してパントリーに戻る',
      textButtonTitle: _ctx.completeDialogMessageShopping,
      onPositiveClick: _ctx.onClickCompliteButton,
      onTextbuttonClick: _ctx.onClickCompliteText
    }, null, 8, ["isShowDialog", "textButtonTitle", "onPositiveClick", "onTextbuttonClick"]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: !!_ctx.handleApiError,
      dialogType: 9,
      title: _ctx.getApiErrorTitle,
      message: _ctx.getApiErrorMessage,
      negativeLabel: _ctx.ERROR_BUTTON_LABEL,
      onNegativeClick: _ctx.closeError
    }, null, 8, ["isShowDialog", "title", "message", "negativeLabel", "onNegativeClick"])
  ]))
}